module.exports = __webpack_public_path__ + "img/logo1.b2ae913d.jpg";